import { IconProps, SvgIcon } from 'modules/miles/shared/components/Icon/SvgIcon';
import React from 'react';

const WarningTriangleDangerPath = (
  <path fillRule='evenodd' clipRule='evenodd' d='M12 1.5L1 22.5H23L12 1.5ZM11 16V10H13V16H11ZM11 18V20H13V18H11Z' fill='currentColor' />
);

export const WarningTriangleDanger = (props: IconProps) => <SvgIcon path={WarningTriangleDangerPath} {...props} />;
